export const getUrlToRedirect = (param) => {
  let url = '';
  switch (param) {
    case 'my-account' || 'myAccount' || '?%2my-account':
      url = '/my-account';
      break;

    case 'authPlugin' || 'authplugin' || '?%2Fauth%2Fplugin':
      url = '/auth/plugin';
      break;

    default:
      url = '/my-account';
      break;
  }
  return url;
};
